<template>
  <div class="no-data-wrapper">
    <slot name="image">
      <div class="no-data-image"></div>
    </slot>

    <div class="no-data-title" v-if="slots.title">
      <slot name="title"></slot>
    </div>

    <div class="no-data-text" :class="{'extra-margin': !slots.title}" v-if="slots.text">
      <slot name="text" />
    </div>

    <div class="no-data-button">
      <slot name="button" />
    </div>
  </div>
</template>

<script setup>
import {useSlots} from "vue";

const slots = useSlots();
</script>

<style lang="scss" scoped>
@import "../assets/sass/theme_variables";

.no-data-wrapper {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  ::v-slotted(img), img {
    max-width: 100%;
  }
}

.no-data-image {
  width: toRem(254);
  height: toRem(254);
  margin: 0 auto;
  background: url("../assets/images/no-data.png");
  background-size: contain;

  @media (max-width: $tabletBreakpoint) {
    width: toRem(196);
    height: toRem(196);
  }
}

.no-data-title {
  margin-top: toRem(24);
  font-size: toRem(18);
  font-weight: bold;
}

.no-data-text {
  margin-top: toRem(5);
  color: $textSecondaryColor;
  width: toRem(254);

  &.extra-margin {
    margin-top: toRem(20);
  }
}

.no-data-button {
  margin-top: toRem(20);
  width: toRem(254);
}
</style>
